import { request } from "@/utils/request";

//  考试管理 - 查询批量导出成绩列表（试卷组卷-添加试卷列表）
export const addPapers = data => {
  return request({
    method: "POST",
    url: "/api/overridePaper/paper/list",
    data
  });
};
//  添加试卷
export const getPaperStryle = data => {
  return request({
    method: "POST",
    url: "/api/overridePaper/getPaperStryle/list",
    data
  });
};
//  试卷组卷-题量及分数设置
export const getTestStyle = data => {
  return request({
    method: "POST",
    url:
      "/api/overridePaper/getPaperStryle/getTestStyle",
    data
  });
};
// 试卷加密（检查是否有独立密码）
export const checkCryptoPwd = data => {
  return request({
    method: "POST",
    url: "/api/usercenter/cryptopwd/checkCryptoPwd",
    data
  });
};
// 校验独立密码
export const verifyCryptoPwd = data => {
  return request({
    method: "POST",
    url: "/api/usercenter/cryptopwd/verifyCryptoPwd",
    data
  });
};
// 试卷加密（查询试卷列表）
export const cryptoexamlist = data => {
  return request({
    method: "POST",
    url: "/api/exammanage/examcrypto/cryptoexamlist",
    data
  });
};
// 试卷加密解密
export const cryptoExam = data => {
  return request({
    method: "POST",
    url: "/api/exammanage/examcrypto/cryptoexam",
    data
  });
};
// 设置独立密码
export const setCryptoPwd = data => {
  return request({
    method: "POST",
    url: "/api/usercenter/cryptopwd/setCryptoPwd",
    data
  });
};
// 撤销独立密码
export const cancelCryptoPwd = data => {
  return request({
    method: "POST",
    url: "/api/usercenter/cryptopwd/cancelCryptoPwd",
    data
  });
};
// 个人中心 - 修改独立密码
export const updateCryptoPwd = data => {
  return request({
    method: "POST",
    url: "/api/usercenter/cryptopwd/updateCryptoPwd",
    data
  });
};
// 个人中心  基本信息
export const getUserInfo = data => {
  return request({
    method: "POST",
    url: "/api/userCenter/userInfo/getUserInfo",
    data
  });
};
// 个人中心 修改基本信息
export const updateUserInfo = data => {
  return request({
    method: "POST",
    url: "/api/userCenter/userInfo/updateUserInfo",
    data
  });
};
// 个人中心修改密码
export const updatePassWord = data => {
  return request({
    method: "POST",
    url: "/api/userCenter/password/updatePassWord",
    data
  });
};
// 个人中心 意见反馈
export const questionFeedback = data => {
  return request({
    method: "POST",
    url: "/api/userCenter/questionFeedback/questionFeedback",
    data
  });
};
// 个人中心 开通科目
export const getSubject = data => {
  return request({
    method: "POST",
    url: "/api/userCenter/subject/getSubject",
    data
  });
};
// 个人中心消息通知
export const getUserNoticeList = data => {
  return request({
    method: "POST",
    url: "api/notice/noticeManage/getUserNoticeList",
    data
  });
};
// 个人中心查看消息通知
export const userCheckNotice = data => {
  return request({
    method: "POST",
    url: "/api/notice/noticeManage/userCheckNotice",
    data
  });
};
// 判断是否要消息通知
export const newMsgCount = data => {
  return request({
    method: "POST",
    url: "/api/notice/noticeManage/newMsgCount",
    data
  });
};